<template>
    <ui-field v-bind="this.$props">
        <div class="relative bg-white rounded-md shadow-sm -space-y-px">
            <label
                v-for="(option, index) in options"
                :key="option.value"
                class="relative border px-4 py-3 flex flex-col cursor-pointer m-0"
                :class="{
                    'rounded-t-md': index === 0,
                    'rounded-b-md': index === options.length - 1,
                    'bg-blue-50 border-blue-300 z-10': option.value === value,
                    'border-gray-300': option.value !== value,
                    'md:grid md:grid-cols-2': !! option.text,
                }"
            >
                <div class="flex items-center text-sm">
                    <input
                        type="radio"
                        class="h-4 w-4 mt-0.5 cursor-pointer text-blue-600 border-gray-300 focus:ring-blue-500"
                        :name="name"
                        :value="option.value"
                        :checked="option.value === value"
                        @input="$emit('input', $event.target.value)"
                    >
                    <span class="ml-3 font-medium text-gray-900" v-text="option.label"></span>
                </div>
                <p
                    v-if="option.text"
                    class="text-gray-500 font-normal ml-6 pl-1 text-sm md:ml-0 md:pl-0 md:text-right"
                    :class="option.value === value ? 'text-blue-700' : 'text-gray-500'"
                    v-text="option.text"
                ></p>
            </label>
        </div>
    </ui-field>
</template>

<script>
export default {
    props: {
        value: null,
        label: String,
        name: String,
        error: String,
        warning: String,
        info: String,
        options: Array,
    },
}
</script>
